import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ConfirmModalComponent from "common/components/modals/commonConfirmModal";

import { paths } from "config/paths";

import { EModals } from "store/modals/types";
import { modalStateSelector } from "store/modals/selectors";
import { closeModal } from "store/modals/reducers";
import { deleteMonitoredWalletFailure, deleteMonitoredWalletRequest } from "store/monitoredWallets/reducers";
import { deleteWalletSelector, historicalImportSelector } from "store/monitoredWallets/selectors";

import compressText from "utils/compressText";

export const MonitoredWalletsDeleteModal: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const deleteData = useSelector(deleteWalletSelector);
  const { data } = useSelector(historicalImportSelector);
  const [deleteTransfers] = useState<boolean>(false);
  const walletModal = useSelector(modalStateSelector(EModals.monitoredWalletsDelete));
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (deleteData.data) {
      dispatch(deleteMonitoredWalletFailure(null));
      dispatch(closeModal(EModals.monitoredWalletsDelete));
      history.push(paths.TRANSFERS_MONITORED_WALLETS);
    }
  }, [deleteData.data]);

  return (
    <ConfirmModalComponent
      visible={Boolean(walletModal?.open)}
      handleClick={() => {
        if (!deleteData.fetching) {
          dispatch(deleteMonitoredWalletRequest({ id: id || (data?.id as string), delete_transfers: deleteTransfers }));
        }
      }}
      fetching={deleteData.fetching}
      close={() => dispatch(closeModal(EModals.monitoredWalletsDelete))}
      title={t("action.delete") + (Boolean(data?.address) ? ` "${compressText(data?.address as string)}"?` : '?')}
      danger={true}
      description={t("amlRiskSettings.deleteModalDescription")}
      buttonTitle={t("action.delete")}
    />
  );
};
